export default __webpack_public_path__ + "static/media/logo.07db8741.png";